module.exports = __webpack_public_path__ + "img/FidelityBank.5a271847.png";